import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {StepsWizardEntry} from '@component/steps-wizard/steps-wizard.adapter';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {PaginationService} from '@component/pagination/service/pagination.service';
import {RoleEnum} from '@core/security/enum/role.enum';
import {AuthorizationService} from '@core/security/services/authorization.service';

@Component({
    selector: 'app-exam-question-list',
    templateUrl: './exam-question-list.component.html',
    styleUrls: ['./exam-question-list.component.scss'],
})
export class ExamQuestionListComponent implements OnInit, OnChanges {
    @Input()
    entries!: StepsWizardEntry[];

    @Input()
    isHandedIn = false;

    protected readonly buttonType = ButtonTypeEnum;

    isOpen = false;

    hasAnswerCount: number = 0;

    isTeacher: boolean = false;

    constructor(
        private paginationService: PaginationService,
        private authorizationService: AuthorizationService,
    ) {
        this.isTeacher = this.authorizationService.isGranted(RoleEnum.RoleTeacher);
    }

    ngOnInit() {
        this.handleCountHasAnswer();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.entries && !changes.entries.firstChange && !this.isTeacher) {
            this.entries = [...changes.entries.currentValue];
            this.handleCountHasAnswer();
        }

        if (changes.entries && changes.entries.previousValue && this.isTeacher) {
            this.entries = [...changes.entries.previousValue];
            this.handleCountHasAnswer();
        }
    }

    toggleMenu(): void {
        this.isOpen = !this.isOpen;
    }

    closeMenu(): void {
        this.isOpen = false;
    }

    handleCountHasAnswer(): void {
        this.hasAnswerCount = this.entries.filter(item => item.hasAnswer === true).length;
    }

    handleMappedPageEvent(page: StepsWizardEntry): void {
        this.paginationService.setCurrentPage(page.index + 1);
        this.closeMenu();
    }

    finishExam(): void {
        this.paginationService.setCurrentPage(this.entries.length);
        this.closeMenu();
    }
}
